import moment from 'moment';

export default {
  normalizers: {
    alphanumeric: (value) => value.replace(/[^aA-Z0-9\s]/, '').replaceAll(' ', ''),
    alphanumericStrict: (value) => value?.replace(/[^a-zA-Z0-9]/g, ''),
    alphanumericUpperCase: (value) =>
      value
        ?.toUpperCase()
        .replace(/[^aA-Z0-9\s]/, '')
        .replaceAll(' ', ''),
    ciSerial: (value) =>
      value
        ?.toUpperCase()
        .replace(/[^A-Z0-9]/g, '')
        .replace(/^([^A-Z0-9]|(.).*?[A-Z])/g, '')
        .replaceAll(' ', ''),
    numeric: (value) => value.replace(/[^0-9\s]/, '').replaceAll(' ', ''),
    numberWithThousand: (value) =>
      value
        ?.toString()
        .replace(/[^0-9\s]/g, '')
        .replaceAll(' ', '')
        .replaceAll('.', '')
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
    requiredCheckbox: (value) => value || undefined,
    trackingNumber: (value) => value?.replace(/[^0-9]/g, '').replace(/\B(?=(\d{4})+(?!\d))/g, '-'),
  },
  date: {
    dateDisablers: {
      disabledDate(current) {
        return current && current > moment().endOf('day');
      },
      minAge(age) {
        return (current) => current && moment().diff(current, 'years') < age;
      },
    },
    format: {
      day: 'DD/MM/YYYY',
    },
    defaultValue: {
      yearsAgo(years) {
        return moment().subtract(years, 'years');
      },
    },
  },
  validateMessages: {
    required: 'Campo obligatorio',
    types: {
      email: 'Email no válido',
    },
    string: { len: 'Debe ser de ${len} dígitos', min: 'Debe ser de al menos ${min} caracteres' },
  },
  inputProps: {
    noPaste: {
      onPaste: (e) => e.preventDefault(),
      onDrop: (e) => e.preventDefault(),
      autoComplete: 'off',
    },
  },
};
